import React from "react";
import { Link } from "react-router-dom";
import { Typography, Button } from "@mui/material";
import NotFoundImage from "../not-found-image.png";

const NotFoundPage = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: "2rem",
      }}
    >
      <Typography variant="h4" gutterBottom>
        Oops! Sayfa bulunamadı.
      </Typography>
      <img
        src={NotFoundImage}
        alt="Not Found"
        style={{ width: "300px", height: "auto", marginTop: "2rem" }}
      />
      <Typography variant="body1" align="center" style={{ marginTop: "2rem" }}>
        Aradığınız sayfa maalesef mevcut değil. Belki de yanlış bir adrese
        gittiniz.
      </Typography>
      <Button
        variant="contained"
        component={Link}
        to="/"
        style={{ marginTop: "2rem" }}
      >
        Anasayfaya Dön
      </Button>
    </div>
  );
};

export default NotFoundPage;
